"use strict";

// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";
// import styles bundle
import "swiper/css/bundle";

import Drift from 'drift-zoom';
import 'drift-zoom/dist/drift-basic.css';

export function topSwiper() {
  /**
   * mv
   */
  const topMvSwiper = new Swiper("#topMvSwiper", {
    loop: true,
    loopAdditionalSlides: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: "fade",
    speed: 2000,
    watchSlidesProgress: true,
    watchOverflow: true,
  });
}

export function newsSwiper() {
  /**
   * mv
   */
  const newsSwiper = new Swiper("#newsSwiper", {
    // loop: true,
    // loopAdditionalSlides: 1,
    spaceBetween: 30,
    speed: 2000,
    watchSlidesProgress: true,
    watchOverflow: true,
    slidesPerView: 1.15,
    breakpoints: {
      414: {
        slidesPerView: 1.5,
      },
      667: {
        slidesPerView: 2.5,
      },
      768: {
        slidesPerView: 3.2,
      },
    },
  });
}

const driftOptions = {
  paneContainer: document.body,  // パネルをbodyに表示
  inlinePane: true,              // 同じページ内に虫眼鏡表示
  hoverBoundingBox: true,        // ボックスに合わせた拡大表示
};
export function productSwiper() {
  /**
   * productSingle
   */

  var productSwiper = new Swiper("#productSwiper", {
    spaceBetween: 20,
    loop: true,
    loopAdditionalSlides: 1,
    speed: 3000,
    watchSlidesProgress: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: "#productSwiperNext",
      prevEl: "#productSwiperPrev",
    },
    on: {
      init: function () {
        setupDrift();
      },
      slideChangeTransitionEnd: function () {
        setupDrift();
      }
    }
  });
  function setupDrift() {
    // すでにインスタンスがあれば削除
    if (window.driftInstance) {
      window.driftInstance.destroy();
    }

    // スライド内の拡大対象の画像を取得
    const targetImage = document.querySelector('#productSwiper .swiper-slide-active .my-swiper-image');

    if (targetImage) {
      window.driftInstance = new Drift(targetImage, driftOptions);
    }
  }

}
export function productSingleImageZoom() {
  const targetImage = document.querySelector('.my-single-image');

  if (targetImage) {
    new Drift(targetImage, driftOptions);
  }
}